import classNames from 'classnames';
import React from 'react';


export interface SpinnerProps {
	text: string;
	light?: boolean;
	centered?: boolean;
}

export const Spinner: React.FC<SpinnerProps> = ({ text, light = false, centered = false }: SpinnerProps) => (
	<div className={classNames('d-inline-flex align-items-center p-3', centered ? ' m-auto' : '')}>
		<div className={`spinner spinner--${light ? 'light' : 'dark'} d-inline-block`} />
		<p className={`ml-3 mb-0 ${light ? 'text-white' : ''}`}>{text}</p>
	</div>
);
